import $ from '@rover/globals/jquery';

const CUSTOMER_SUPPORT_PHONE = '888-453-7889';

export default class {
  static showToast({
    severity = 'info',
    message = '',
    container = '.js-alerts-container',
    showCloseButton = true,
  } = {}) {
    const parentContainer = $(container);
    const severityClass =
      ['success', 'info', 'warning', 'danger'].indexOf(severity) !== -1 ? severity : 'info';
    const closeButton = showCloseButton
      ? '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>'
      : '';
    const rendered = `
            <div class="alert alert-${severityClass} padded fade in js-alert">
                ${closeButton}
                ${message}
            </div>
        `;
    parentContainer.append(rendered);
  }

  static showAlert({ attemptedAction = 'processing your request' } = {}) {
    alert(
      `Oops, we encountered an error while ${attemptedAction}. Please try again shortly or contact Customer Support at ${CUSTOMER_SUPPORT_PHONE}.`
    );
  }

  static alertApiError(err) {
    let formattedError;

    if (typeof err === 'object') {
      formattedError = JSON.stringify(err);
    } else {
      formattedError = err;
    }

    if ($('.js-alerts-container').length) {
      this.showToast({ message: formattedError, severity: 'danger' });
      scrollTo($('.js-alerts-container'), 0);
    } else {
      this.showAlert({
        attemptedAction: `processing your request: ${formattedError}`,
      });
    }
  }

  static failedApiResponse(response) {
    const errors = this.parseResponse(response);
    if (errors === undefined || errors.length == 0) {
      this.alertApiError(
        `Oops, we encountered an error while processing your request. Please try again shortly` +
          ` or contact Customer Support at ${CUSTOMER_SUPPORT_PHONE}.`
      );
      return;
    }
    errors.forEach(err => this.alertApiError(err));
  }

  static parseResponse(response = {}) {
    const errors = [];
    let json;

    if (response.status && response.status === 429) {
      errors.push('Please slow down and try again in a few minutes');
    } else if ([403, 405, 500].includes(response.status)) {
      errors.push(
        'We were unable to process your request. Please try again shortly or contact Customer Support at 888-453-7889.'
      );
    } else {
      json =
        response.response ||
        (response.responseText && JSON.parse(response.responseText)) ||
        response.data;
    }

    if (json) {
      let { error_description: errorDescription, non_field_errors: nonFieldErrors, error } = json;

      const detail = json.detail;

      if (detail) {
        errors.push(detail);
      }

      if (error && typeof error === 'object') {
        if (error.error_description) errorDescription = error.error_description;
        if (error.non_field_errors) nonFieldErrors = error.non_field_errors;
        if (!errorDescription && !nonFieldErrors) error = JSON.stringify(error);
      }

      if (errorDescription) errors.push(errorDescription);
      if (typeof error === 'string') errors.push(error);

      if (Array.isArray(nonFieldErrors)) {
        errors.push(...nonFieldErrors);
      } else if (nonFieldErrors) {
        errors.push(nonFieldErrors);
      }
    }

    return errors;
  }
}



// WEBPACK FOOTER //
// ../utilities/Alerts.js